import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { useNotificationCycles } from 'hooks/useNotificationScheduler';
import CycleStatsCards from './components/CycleStatsCards';
import SchedulerControlPanel from './components/SchedulerControlPanel';
import CyclesTable from './components/CyclesTable';
import AttemptsPanel from './components/AttemptsPanel';

export default function NotificationSchedulerPage() {
  const { data: cyclesData, isLoading: cyclesLoading, refetch: refetchCycles } = useNotificationCycles();
  const cycles = cyclesData?.data ?? [];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 0.5 }}>
        Scheduler — Notifications Permis de Travail
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Suivi des cycles de notification automatique et déclenchement manuel
      </Typography>

      <CycleStatsCards cycles={cycles} loading={cyclesLoading} />

      <Divider sx={{ my: 2 }} />

      <SchedulerControlPanel onBatchTriggered={refetchCycles} />

      <CyclesTable rows={cycles} loading={cyclesLoading} />

      <AttemptsPanel />
    </Box>
  );
}
